module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_agder_neg.57a74bf0.svg";